import { Box, Button, Card, Heading, Icon, Image, Paragraph } from '@zillow/constellation-10';
import { IconBlueprintFilled } from '@zillow/constellation-icons';

import Maintenance from '../../images/maintenance.svg';

type Props = {
  setDisplayCreateNewTaskModal: (value: boolean) => void;
  variant?: 'illustration' | 'card';
};

export const NoTasksEmptyState = ({ setDisplayCreateNewTaskModal, variant = 'illustration' }: Props) => {
  const content = (
    <>
      <Box aria-hidden="true" css={{ marginBottom: 'default' }}>
        {variant === 'illustration' ? (
          <Image src={Maintenance} css={{ width: '120px', height: '120px' }} alt="" role="presentation" />
        ) : (
          <Icon size="md" css={{ color: 'icon.subtle' }}>
            <IconBlueprintFilled />
          </Icon>
        )}
      </Box>

      <Heading level={2} textStyle="heading-xs" css={{ marginBottom: 'tightest' }}>
        Track your maintenance tasks
      </Heading>

      <Paragraph css={{ marginBottom: 'default' }}>
        Keep track of routine or emergency repairs, and their resolutions, all in one place. Create tasks, record costs,
        add photos, and more.
      </Paragraph>

      <Button tone="brand" emphasis="filled" onClick={() => setDisplayCreateNewTaskModal(true)}>
        Create new task
      </Button>
    </>
  );

  if (variant === 'card') {
    return (
      <Card tone="neutral" elevated={false} css={{ textAlign: 'left' }}>
        {content}
      </Card>
    );
  }

  return <Box css={{ textAlign: 'left' }}>{content}</Box>;
};
